"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMD5Hash = getMD5Hash;
exports.buildStorageKeySuffix = buildStorageKeySuffix;
exports.encodeBase64 = encodeBase64;
exports.attributeEncodeBase64 = attributeEncodeBase64;
exports.decodeBase64 = decodeBase64;
exports.obfuscatePrecomputedBanditMap = obfuscatePrecomputedBanditMap;
exports.obfuscatePrecomputedFlags = obfuscatePrecomputedFlags;
const base64 = require("js-base64");
const SparkMD5 = require("spark-md5");
function getMD5Hash(input, salt = '') {
    return new SparkMD5().append(salt).append(input).end();
}
/**
 * Builds a storage key suffix from an API key.
 * @param apiKey - The API key to build the suffix from
 * @returns A string suffix for storage keys
 * @public
 */
function buildStorageKeySuffix(apiKey) {
    // Note that we hash the API key and use the first 16 characters of the digest.
    const hashed = getMD5Hash(apiKey);
    return hashed.slice(0, 16);
}
function encodeBase64(input) {
    return base64.encode(input);
}
function attributeEncodeBase64(input) {
    if (typeof input !== 'string') {
        return encodeBase64(String(input));
    }
    return encodeBase64(input);
}
function decodeBase64(input) {
    return base64.decode(input);
}
function obfuscatePrecomputedBanditMap(salt, bandits) {
    return Object.fromEntries(Object.entries(bandits).map(([variationValue, bandit]) => {
        const hashedKey = getMD5Hash(variationValue, salt);
        return [hashedKey, obfuscatePrecomputedBandit(bandit)];
    }));
}
function obfuscatePrecomputedBandit(banditResult) {
    return {
        banditKey: encodeBase64(banditResult.banditKey),
        action: encodeBase64(banditResult.action),
        actionProbability: banditResult.actionProbability,
        optimalityGap: banditResult.optimalityGap,
        modelVersion: encodeBase64(banditResult.modelVersion),
        actionNumericAttributes: encodeAttributes(banditResult.actionNumericAttributes),
        actionCategoricalAttributes: encodeAttributes(banditResult.actionCategoricalAttributes),
    };
}
function encodeAttributes(attributes) {
    return Object.fromEntries(Object.entries(attributes).map(([attributeKey, attributeValue]) => [
        encodeBase64(attributeKey),
        attributeEncodeBase64(attributeValue),
    ]));
}
function obfuscatePrecomputedFlags(salt, precomputedFlags) {
    const response = {};
    Object.keys(precomputedFlags).forEach((flagKey) => {
        const assignment = precomputedFlags[flagKey];
        // Encode extraLogging keys and values.
        const encodedExtraLogging = Object.fromEntries(Object.entries(assignment.extraLogging ?? {}).map((kvArr) => kvArr.map(encodeBase64)));
        const hashedKey = getMD5Hash(flagKey, salt);
        response[hashedKey] = {
            flagKey: hashedKey,
            variationType: assignment.variationType,
            extraLogging: encodedExtraLogging,
            doLog: assignment.doLog,
            allocationKey: encodeBase64(assignment.allocationKey ?? ''),
            variationKey: encodeBase64(assignment.variationKey ?? ''),
            variationValue: encodeBase64(assignment.variationValue),
        };
    });
    return response;
}
//# sourceMappingURL=obfuscation.js.map